import {
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  Radio,
  RadioGroup,
  Select,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import React, { useEffect, useLayoutEffect } from 'react';
import { MenuItem } from '@material-ui/core';
import { makeStyles, TextField } from '@material-ui/core';
import { Field, Form } from 'react-final-form';
import {
  composeValidators,
  requiredFn,
  emailFn,
  countries,
  states,
  roles,
} from './utils';
import { useHistory } from 'react-router-dom';
import { submitAssessment } from '../../api';
import { useAnswerContext } from '../../context';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '30px',
    position: 'relative',
    zIndex: 10,
  },
  formStyle: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    gap: '30px',
  },
  header: {
    fontWeight: 500,
    margin: 0,
    maxWidth:900,
    textAlign: 'center',
    color: 'rgb(32, 33, 36)',
    [theme.breakpoints.down('md')]: {
      fontSize: '34px',
      lineHeight: '42px',
      letterSpacing: '-0.3px',
      marginTop:40
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '44px',
      lineHeight: '52x',
      letterSpacing: '-0.5px',
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  mobileImage: {
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  image: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
    [theme.breakpoints.up('md')]: {
      height: 320,
      marginLeft: 110,
      transform: 'translateY(-70px)',
    },
  },
  text: {
    fontSize: '18px',
    lineHeight: '30px',
    letterSpacing: '0.2px',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      marginTop: 20,
    },
    [theme.breakpoints.up('md')]: {
      marginTop: 40,
    },
  },
  footer: {
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignContent: 'center',
    marginTop: 10,
  },
  newLogo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 30,
  },
  radioLabel: {
    flex: 1,
    fontSize: '16px',
    lineHeight: '30px',
    letterSpacing: '0.2px',
    marginTop: 20,
  },
}));

const fieldInputBuilder = (
  name: string,
  label: string,
  ...validators: Array<(value: string) => undefined | string>
) => (
  <Field
    name={name}
    validate={
      validators ? composeValidators(requiredFn, ...validators) : requiredFn
    }
  >
    {({ input, meta }) => (
      <TextField
        error={meta.error && meta.touched}
        label={label}
        variant="filled"
        {...input}
        required
        helperText={meta.error && meta.touched ? meta.error : ''}
      />
    )}
  </Field>
);

const FieldSelectBuilder: React.FC<{
  name: string;
  label: string;
  options: Array<{ name: string; code: string }>;
}> = ({ name, label, options }) => {
  return (
    <Field name={name} validate={requiredFn}>
      {({ input, meta }) => (
        <FormControl variant="filled" error={meta.error && meta.touched}>
          <InputLabel id={name}>{label}</InputLabel>
          <Select labelId={name} {...input}>
            {options.map(({ code, name }) => (
              <MenuItem key={code} value={code}>
                {name}
              </MenuItem>
            ))}
          </Select>
          {meta.error && meta.touched ? (
            <FormHelperText>{meta.error}</FormHelperText>
          ) : null}
        </FormControl>
      )}
    </Field>
  );
};

export const MainFrom = () => {
  const {
    root,
    formStyle,
    header,
    footer,
    radioLabel,
    newLogo,
    container,
  } = useStyles();
  const history = useHistory<any>();
  const { values, goToResult } = useAnswerContext();

  useEffect(() => {
    if (!history.location.state?.form) {
      const search = history.location.search;
      history.push(
        history.location.pathname
          ? history.location.pathname + search
          : '/' + search,
        { form: true },
      );
    }
  }, [history]);

  useLayoutEffect(() => {
    window.scrollTo({ top: 0 })
  }, []);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div className={root}>
      <div className={newLogo}>
        <img
          width="200"
          src={process.env.PUBLIC_URL + '/google_cloud_logo_healthcare.png'}
          alt="google cloud logo"
        />
        <h2 className={header}>Discover where your organization is on its data-drive supply chain  journey.</h2>
      </div>
      <div className={container}>
        <Form
          onSubmit={(data: any) => {
            console.log(2, values)
            submitAssessment(data, {
              Asessment: 'Supplychain',
              ...values,
            });
            goToResult();
          }}
          render={({ handleSubmit, values }) => {
            const countryCode = values['CountryCode'];
            const stateData = states.find((x) => x.code === countryCode);
            return (
              <form
                onSubmit={handleSubmit}
                style={{
                  maxWidth: 620,
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div style={{ lineHeight: '30px', fontSize: 18, letterSpacing: 0.2, marginTop: 40, marginBottom: 50, textAlign: 'center', }}>
                  Complete the form to see your results and you’ll receive a
                  guide outlining the best approach to harmonizing your data and
                  maximizing its potential.
                </div>
                <div className={formStyle}>
                  {fieldInputBuilder('FirstName', 'First name')}
                  {fieldInputBuilder('LastName', 'Last name')}
                  {fieldInputBuilder('Company', 'Business name')}
                  {fieldInputBuilder('Title', 'Job title')}
                  <FieldSelectBuilder
                    name="Job_Role__c"
                    label="Job role"
                    options={roles.map((x) => ({ name: x, code: x }))}
                  />
                  <FieldSelectBuilder
                    name="CountryCode"
                    label="Country"
                    options={countries}
                  />

                  {stateData ? (
                    <FieldSelectBuilder
                      name="StateCode"
                      label={stateData.name}
                      options={stateData.state}
                    />
                  ) : null}
                  {fieldInputBuilder('Phone', 'Business mobile phone')}
                  {fieldInputBuilder('Email', 'Email', emailFn)}
                </div>
                <div className={radioLabel}>
                  Sign me up to receive news, product updates, event information
                  and special offers about Google Cloud from Google. I
                  understand my personal data will be processed in accordance
                  with Google’s{' '}
                  <a href="https://policies.google.com/privacy" target="blank">
                    Privacy Policy
                  </a>
                  .
                </div>
                <div className={footer}>
                  <Field
                    name="Opt_In__c"
                    validate={(val: string) =>
                      !val ? 'This field is required' : undefined
                    }
                    type="checkbox"
                  >
                    {({ input, meta }) => (
                      <div
                        style={{
                          position: 'relative',
                          alignSelf: 'flex-start',
                        }}
                      >
                        <RadioGroup
                          row
                          aria-label="position"
                          {...input}
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                          }}
                        >
                          <FormControlLabel
                            value="yes"
                            control={<Radio color="primary" />}
                            label="Yes"
                          />
                          <FormControlLabel
                            value="no"
                            control={<Radio color="primary" />}
                            label="No"
                          />
                        </RadioGroup>
                        {meta.error && !meta.pristine ? (
                          <FormHelperText
                            style={{
                              position: 'absolute',
                              bottom: '-14px',
                              left: 0,
                              whiteSpace: 'nowrap',
                            }}
                            error
                          >
                            {meta.error}
                          </FormHelperText>
                        ) : null}
                      </div>
                    )}
                  </Field>
                  <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    style={{
                      alignSelf: matches ? 'center' : 'flex-start',
                      whiteSpace: 'nowrap',
                      marginTop: 15,
                    }}
                  >
                    View your result
                  </Button>
                </div>
              </form>
            );
          }}
        />
      </div>
    </div>
  );
};
